export default {
	'permission-type': 'Permission type',
	'read-only': 'Read only',
	'read-and-write': 'Read and write',
	'no-permission': 'No permission',
	Users: 'Users',
	'the-role': 'the role?',
	'deleting-role-alert': 'Deleting a role will delete all users of the role.',
	'the-user': 'the user?',
	
	'add-user': 'Add user',
	'edit-user': 'Edit user',

	'password-note': 'Note: leave password fields empty if you don\'t want to change it',

	permissions: {
		'managing-purchase': 'Offers',
		'managing-purchase-simulation': 'Offers simulation',
		'managing-receives': 'Purchases',
		sales: 'Sales',
		'managing-inventory': 'Inventory',
		'managing-items': 'Items',
		'managing-accounts': 'Accounts',
		'managing-users': 'Users',
		statistics: 'Statistics',
		'fiscal-years': 'Fiscal years',
		'material-journal': 'Material journal',
		'managing-settings': 'Settings',
		'managing-production-orders': 'Production orders',
		'managing-order-results': 'Order results',
		'managing-items-statement': 'Items statement',
		'managing-experimental-simulation': 'Experimental simulation',
		'managing-material-simulation': 'Material simulation',
		'managing-receiving-journals': 'Receiving journals',
		'delivery-journals': 'Delivery journals'
	},

	'permissions-description': {
		'managing-purchase': 'Permission to manage offers',
		'managing-purchase-simulation': 'Permission to manage offers simulation',
		'managing-receives': 'Permission to manage purchases',
		sales: 'Permission to manage contracts and deliveries',
		'managing-inventory': 'Permission to manage material journals, inventory and items statements',
		'managing-items': 'Permission to manage items',
		'managing-accounts': 'Permission to manage accounts',
		'managing-users': 'Permission to manage roles and users',
		statistics: 'Viewing system statistics',
		'fiscal-years': 'Permission to manage fiscal years',
		'material-journal': 'Permission to use material journal to change owners',
		'managing-settings': 'Permission to managing settings',
		'managing-production-orders': 'Permission to managing production orders',
		'managing-order-results': 'Permission to managing order results',
		'managing-items-statement': 'Permission to managing items statement',
		'managing-experimental-simulation': 'Permission to managing experimental simulation',
		'managing-material-simulation': 'Permission to managing material simulation',
		'managing-receiving-journals': 'Permission to managing receiving journals',
		'delivery-journals': 'Permission to managing delivery journals'
	}
}